<template>
  <section class="yield-panel crop-panel">
    <div class="yield-title">作物产量预估</div>
    <div class="crop-list">
      <div v-for="item in crops" :key="item.name" class="crop-item">
        <span class="round-icon"><img src="../../assets/img/zw.png" alt="" /></span>
        <b>{{ item.name }}</b>
        <strong class="aqua-text">{{ item.value }}</strong>
      </div>
    </div>
  </section>
</template>

<script setup>
const crops = [
  { name: "小麦", value: "565公斤/亩", icon: "麦" },
  { name: "玉米", value: "610公斤/亩", icon: "玉" },
  { name: "花生", value: "330公斤/亩", icon: "花" },
  { name: "大豆", value: "185公斤/亩", icon: "豆" },
];
</script>

<style lang="less" scoped>
@import "./YieldLeftShared.less";

.crop-panel {
  padding: 20px 28px 18px;
}

.crop-list {
  display: grid;
  gap: 50px;
  margin-top: 60px;
}

.crop-item {
  display: grid;
  grid-template-columns: 80px 78px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  color: #ffffff;
}

.crop-item b {
  font-size: 30px;
  line-height: 32px;
  text-align: left;
}

.crop-item strong {
  font-size: 31px;
  line-height: 38px;
  text-align: right;
  white-space: nowrap;
}
.round-icon{
  
  img{
    width: 40px;
    height: 40px;
  }
}
</style>
